import type { RouteLineString } from '@sixam/shared/route-core';

import { RoutePreview } from '@/components/routes/route-preview';

type RouteMapPreviewProps = Readonly<{
  geometry: RouteLineString;
  name: string;
}>;

export function RouteMapPreview({ geometry, name }: RouteMapPreviewProps) {
  return <RoutePreview animate={false} geometry={geometry} name={name} />;
}
